import { Box } from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { ShowByCondition } from '@/components/blocks/ShowByCondition';
import { OutfitTitle } from '@/components/blocks/ModalOutfits/parts/OutfitTitle';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';

export const OutfitHeader = () => {
	const { isMobile, onClose } = useModalOutfitsContext();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: { xs: 'space-between', md: 'flex-end' },
				alignItems: 'center',
				minHeight: { xs: '58px !important', md: '44px !important' },
			}}
		>
			<ShowByCondition condition={isMobile}>
				<OutfitTitle />
			</ShowByCondition>
			<ClearIcon color="inherit" fontSize="medium" sx={{ cursor: 'pointer' }} onClick={onClose} />
		</Box>
	);
};
